const initialState = {status: null, text: null}

const paymentSuccess = (state, payload) => {
  const data = payload && payload.flash
  return data ? {...data, counter: state.counter + 1} : state
}

const paymentError = (state, payload) => {
  const error = payload && payload.error
  return error ? {status: "error", text: error.text, counter: state.counter + 1} : state
}

const flash = (state = initialState, {type, payload}) => {
  switch (type) {
    case "CLEAR_SHOP": return paymentSuccess(state, payload)
    case "PAYMENT_ERROR": return paymentError(state, payload)
    case "FLASH_CLEAR":
    case "PAYMENT_MODAL_CLOSED":
      return {...state, status: null, text: null}
    case "TOUCHLESS_PAYMENT_SUCCESS":
      return {...state, status: "success", text: payload.message.success}
    case "TOKENIZATION_TIMEOUT":
      return {...state, status: "error", text: "Operation timeout"}
    default:
      return state
  }
}

export default flash
